import { getAreaBudgetNavConfig } from './areaBudgetNavConfig';

export function filterAreaBudgets(budgets, area) {
  if (!Array.isArray(budgets)) return [];
  const config = getAreaBudgetNavConfig(area);
  if (!config) return [];
  if (area === 'basecamp') {
    return budgets.filter(
      (b) => b.budget_type === 'basecamp' || b.budget_type === 'management',
    );
  }
  return budgets.filter((b) => b.budget_type === config.budgetType);
}

export function getAreaBudgetEditPath(budget, area) {
  const config = getAreaBudgetNavConfig(area);
  if (!budget?.budget_id || !config) return config?.menuRoute || '/budgets';
  return `${config.routePrefix}/${budget.budget_id}`;
}

export function getAreaBudgetStatusMeta(budget) {
  const status = (budget?.status || 'draft').toLowerCase();
  const isApproved = status === 'approved';
  const isSubmitted = status === 'submitted';
  return {
    status,
    isApproved,
    isSubmitted,
    canDelete: !isSubmitted && !isApproved,
    actionLabel: isApproved ? 'View' : isSubmitted ? 'Review' : 'Edit',
    statusLabel: isApproved ? 'Approved' : isSubmitted ? 'Submitted' : 'Draft',
    statusClass: isApproved ? 'approved' : isSubmitted ? 'submitted' : 'draft',
  };
}

export function canAccessAreaBudgetMenu(area, hasMenuAccess) {
  const config = getAreaBudgetNavConfig(area);
  if (!config) return false;
  return (
    hasMenuAccess(config.menuRoute)
    || hasMenuAccess(config.legacyNewMenuRoute)
    || hasMenuAccess(config.legacyListMenuRoute)
  );
}

export function getPendingNavActionLabel(area, targetPath) {
  const config = getAreaBudgetNavConfig(area);
  if (!config || !targetPath) return 'leave this budget';
  if (targetPath === config.newPath || targetPath === '/budgets/new') {
    return 'start a new budget';
  }
  if (targetPath === '/app') return 'close this budget';
  return 'leave this budget';
}

export function isAreaBudgetRouteActive(area, pathname) {
  const config = getAreaBudgetNavConfig(area);
  return config ? config.isBudgetPage(pathname) : false;
}
